const KEY = "cz_from_whatsapp";

// The patient arrived from a WhatsApp payment link: the pay steps show no footer.
export function markFromWhatsApp() {
    try {
        sessionStorage.setItem(KEY, "1");
    } catch (e) {
        // Without sessionStorage the footer simply stays.
    }
}

export function hideFooterFor(routeName: string | null | undefined): boolean {
    if (routeName === "whatsapp-pay") {
        return true;
    }
    try {
        return routeName === "checkout" && sessionStorage.getItem(KEY) === "1";
    } catch (e) {
        return false;
    }
}
